module.exports = __webpack_public_path__ + "media/3-11.c475c7d5.wav";